export function formatLocalDateTime(value?: unknown): string {
  if (value === undefined || value === null || String(value).trim() === '') return '—';

  const raw = String(value).trim();
  const parsed = new Date(raw);
  if (Number.isNaN(parsed.getTime())) return raw;

  try {
    return new Intl.DateTimeFormat(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: 'numeric',
      minute: '2-digit',
      timeZoneName: 'short',
    }).format(parsed);
  } catch {
    return parsed.toLocaleString();
  }
}

export function parseDateTime(value?: unknown): Date | null {
  if (value === undefined || value === null || String(value).trim() === '') return null;
  const parsed = new Date(String(value).trim());
  return Number.isNaN(parsed.getTime()) ? null : parsed;
}
